module.exports = __webpack_public_path__ + "static/horns_emoji-e4a1d67591a5272f22d8d2bc26446a61.svg";